import React from 'react';
import ReactQuill from 'react-quill';
import { useDispatch, useSelector } from 'react-redux';
import { ApiAnexoSolicitacao } from 'service/api/solicitacao/ApiAnexoSolicitacao';
import { ComentariosSolicitacaoAction } from 'store/ComentariosSolicitacao/ComentariosSolicitacao.action';
import { ComentariosSolicitacaoSelector } from 'store/ComentariosSolicitacao/ComentariosSolicitacao.selector';
import { BotaoCancelar, BotaoSalvar } from 'view/component/Botao/BotoesComuns';
import { Editor } from 'view/component/Editor/Editor';
import { FormikDebug } from 'view/component/Formulario/FormikDebug';
import { MensagemErro } from 'view/component/Formulario/MensagemErro/MensagemErro';
import { MensagensErroServidor } from 'view/component/MensagensErroServidor/MensagensErroServidor';

import { UploadField } from 'view/component/Upload/Upload';


interface NovoComentarioTagConteudoFormularioProps {
  placeholder?: string
  name: string
}

export const NovoComentarioTagConteudoFormulario = React.forwardRef<ReactQuill, NovoComentarioTagConteudoFormularioProps>(({name, ...props}, ref) => {
  const dispatch = useDispatch();
  
  const erros = useSelector(ComentariosSolicitacaoSelector.novo.erros);
  const desabilitarEdicao = () => dispatch(ComentariosSolicitacaoAction.criacao.cancelar());
  
  return <>
    <MensagensErroServidor erro={erros} />
    
    <label className="sr-only" htmlFor={`${name}.mensagem`}>Novo comentário</label>
    <Editor {...props} ref={ref} name={`${name}.mensagem`} />
    <MensagemErro name={`${name}.mensagem`} />

    <UploadField name={`${name}.anexos`} gerarEnderecoEnvio={ApiAnexoSolicitacao.enviarAnexo().gerarEnderecoEnvio} />
    <MensagemErro name={`${name}.anexos`} />

    <footer>
      <BotaoSalvar />
      <BotaoCancelar onClick={desabilitarEdicao} />
    </footer>

    <FormikDebug />
  </>
});